import client from "~/apis/client"

export function subscribeToPush(subscription) {
  const { endpoint, keys } = subscription.toJSON()
  return client.post("/push_subscription", { endpoint, p256dh: keys.p256dh, auth: keys.auth })
}

export function unsubscribeFromPush(endpoint) {
  return client.delete("/push_subscription", { data: { endpoint } })
}
